import { BRAND } from "./tokens";
import type { SectionColor } from "./types";

/**
 * Hex values per section color token. Components apply these via inline
 * styles where the makeStyles class can't reach (e.g. dynamic per-section
 * accent backgrounds in the sidebar / pillar swatches).
 */
export const sectionColorHex: Record<SectionColor, string> = {
  orange: BRAND.gold, // Unternehmensinformation
  pillarOrange: BRAND.pillarOrange,
  blue: BRAND.pillarBlue,
  green: BRAND.pillarGreen,
  black: BRAND.pillarBlack,
  purple: BRAND.purple,
};
